import * as constants from './constants';

const updateAuthTokens = data => ({
  type: constants.UPDATE_AUTH_TOKENS,
  data
});

const setLoginSession = session => ({ type: constants.SET_LOGIN_SESSION, session });

const checkAuthentication = () => ({
  type: constants.CHECK_AUTHENTICATION
});

const login = (userLogin, password, recaptchaValue) => ({
  type: constants.LOGIN,
  userLogin,
  password,
  recaptchaValue
});

const externalLogin = authorization => ({
  type: constants.EXTERNAL_LOGIN,
  authorization
});

const logout = url => ({
  type: constants.LOGOUT,
  url
});

const setAuthentication = (value, { localOnly = false } = {}) => ({
  type: constants.SET_AUTHENTICATION,
  value,
  ...(localOnly ? { localOnly: true } : {})
});

const requestPasswordReset = (resetLogin, recaptchaValue) => ({
  type: constants.REQUEST_PASSWORD_RESET,
  resetLogin,
  recaptchaValue
});

const checkTokenCode = value => ({
  type: constants.CHECK_TOKEN_CODE,
  value
});

const resetPasswordNonAuth = (values, auth) => ({
  type: constants.RESET_PASSWORD_NON_AUTH,
  values,
  auth
});

const registerUser = (values, auth, recaptchaValue, email) => ({
  type: constants.REGISTER,
  values,
  auth,
  recaptchaValue,
  email
});

export {
  checkAuthentication,
  login,
  externalLogin,
  logout,
  setAuthentication,
  setLoginSession,
  requestPasswordReset,
  checkTokenCode,
  resetPasswordNonAuth,
  registerUser,
  updateAuthTokens
};
